import styled from "styled-components";

export const ProgressBar = styled.div<{ percent: number; isShining?: boolean }>`
  position: relative;

  .container {
    position: relative;
    height: 8px;
    background: #eee;
    border-radius: 4px;
    overflow: hidden;

    .progress-bar {
      width: 100%;
      transform-origin: left center;
      height: 100%;
      position: relative;

      .progress-bar-inner {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        transition: width 0.3s ease;
        border-radius: 16px;
      }

      .shine-effect {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background: linear-gradient(
          120deg,
          transparent,
          rgba(255, 255, 255, 0.6),
          transparent
        );
        animation: shine 2s infinite;
        pointer-events: none;
      }
    }
  }
`;
